import React from "react";

function Rating() {
  return <div>Rating</div>;
}

export default Rating;
